import {
  Box,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Chip,
  Button,
  Alert,
  IconButton,
  Tooltip,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import { useErrorStore, type AppError } from '@/stores/useErrorStore.js';

const severityColors: Record<AppError['severity'], 'error' | 'warning' | 'info' | 'success' | 'default'> = {
  fatal: 'error',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

export const ErrorCenter = () => {
  const errors = useErrorStore((s) => s.errors);
  const removeError = useErrorStore((s) => s.removeError);
  const clearErrors = useErrorStore((s) => s.clearErrors);

  return (
    <Paper sx={{ p: 2, mt: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6">Error Center</Typography>
        <Button
          variant="outlined"
          size="small"
          startIcon={<ClearAllIcon />}
          onClick={clearErrors}
          disabled={errors.length === 0}
        >
          모두 지우기
        </Button>
      </Box>
      {errors.length === 0 ? (
        <Alert severity="success">최근 오류가 없습니다.</Alert>
      ) : (
        <List dense>
          {errors.slice(0, 100).map((error) => (
            <ListItem
              key={error.id}
              secondaryAction={
                <Tooltip title="삭제">
                  <IconButton edge="end" size="small" onClick={() => removeError(error.id)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              }
            >
              <ListItemText
                primary={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Chip label={error.severity} color={severityColors[error.severity]} size="small" />
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                      {error.code}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {new Date(error.timestamp).toLocaleString()}
                    </Typography>
                  </Box>
                }
                secondary={
                  <Box>
                    <Typography variant="body2">{error.message}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      Source: {error.source}
                    </Typography>
                    {error.context && (
                      <Typography variant="caption" component="pre" sx={{ display: 'block', mt: 0.5 }}>
                        {JSON.stringify(error.context, null, 2)}
                      </Typography>
                    )}
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
};

export default ErrorCenter;
